import { render } from "./servicesEN.vue?vue&type=template&id=793078fd&scoped=true"
import script from "./servicesEN.vue?vue&type=script&lang=js"
export * from "./servicesEN.vue?vue&type=script&lang=js"

import "./servicesEN.vue?vue&type=style&index=0&id=793078fd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793078fd"]])

export default __exports__